export default __webpack_public_path__ + "static/media/6.7cb733f5.png";